import { AnyAction, Reducer } from 'redux';
import { InventoryState } from '../models/inventoryModel';
import actionTypes from '../types/inventoryTypes';

const initialState: any = {
  doctorsList: null as any,
  doctorsImages: null as any,
  selectedDoctor: null as any,
};

const inventoryReducer: Reducer = (
  state: InventoryState = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SAVE_DOCTORS_LIST: return {
      ...state,
      doctorsList: action.payload,
    };
    case actionTypes.DOCTORS_IMAGES: return {
      ...state,
      doctorsImages: action.payload,
    };
    case actionTypes.SET_SELECTED_DOCTORS_LIST: return {
      ...state,
      selectedDoctor: action.payload,
    };
    case actionTypes.IP_INCLUSION_MASTER_DATA: return {
      ...state,
      inPatientinclusionMaster: action.payload,
    };
    case actionTypes.IP_DEPARTMENT_MASTER_DATA: return {
      ...state,
      inPatientdepartmentMaster: action.payload,
    };
    default: return state;
  }
};

export default inventoryReducer;
